/**
 * The house brand colour and the ink it carries: Pflaum blue under dark text.
 *
 * The stylesheet holds the same two values as `--countdown-color-brand` and
 * `--countdown-color-brand-ink` (styles/tokens.css). They are repeated here for the code
 * that has to decide before a stylesheet is involved: the contrast guardrail choosing an
 * ink, and the drawn favicon. `defaults.test.ts` fails when the two places drift apart.
 */
export const HOUSE_BRAND_COLOR = '#009de0';
export const HOUSE_BRAND_INK = '#1a2332';
/** The first ink the guardrail tries on a tenant colour: most magazine colours carry it. */
export const HOUSE_LIGHT_INK = '#ffffff';
/** The line under an action's title; the calendar page and the backoffice's preview of it. */
export const DEFAULT_ACTION_SUBTITLE = 'Jeden Tag ein neues Türchen mit Fragen und Gewinnen unserer Partner.';
/** The same line in a customer's calendar, which has no partners besides the customer. */
export const CUSTOMER_ACTION_SUBTITLE = 'Jeden Tag ein neues Türchen mit Fragen und Gewinnen.';
/**
 * Neutral fallback theme.
 *
 * Used when a tenant has not configured anything yet, never as a substitute
 * for the white label mandatory elements: operator, imprint and privacy policy
 * have no meaningful default, so they are empty here and the action cannot go
 * live without them (concept 9.2, 10.7).
 */
export const DEFAULT_TENANT_THEME = {
    colors: {},
    typography: {},
    fieldShape: 'square',
    seasonalWorld: 'none',
    logo: null,
    faviconUrl: null,
    fieldTerm: 'field',
    legal: {
        operatorName: '',
        imprintUrl: '',
        privacyUrl: '',
        termsUrl: '',
    },
};
/**
 * True when every white label mandatory element is filled in.
 * The backoffice uses this as a go-live gate.
 */
export function hasCompleteWhiteLabelInfo(theme) {
    const { operatorName, imprintUrl, privacyUrl, termsUrl } = theme.legal;
    return [operatorName, imprintUrl, privacyUrl, termsUrl].every((value) => value.trim().length > 0);
}
//# sourceMappingURL=defaults.js.map